import { closeShift, closeShiftForm, createShift, shiftForm } from '@/api/mutations/shift';
import { useState } from 'react';
import { setCashes, setPending, setShift } from '../../redux/data/dataSlice';
import { useAppDispatch } from '../../redux/hooks';

export const useShift = () => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const start = async (data: shiftForm) => {
    setIsLoading(true);
    try {
      await createShift(data);
      dispatch(setShift(data));
      return true;
    } catch (err: any) {
      if (!err.statusCode) {
        dispatch(
          setPending({
            type: 'START_SHIFT',
            ID: data.ID,
            data: JSON.stringify(data),
          })
        );
        dispatch(setShift(data));
        return true;
      }
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const close = async (data: closeShiftForm) => {
    setIsLoading(true);
    try {
      await closeShift(data);
      dispatch(setShift(null));
      dispatch(setCashes([]));
      return true;
    } catch (err: any) {
      if (!err.statusCode) {
        dispatch(
          setPending({
            type: 'CLOSE_SHIFT',
            ID: data.shiftId,
            data: JSON.stringify(data),
          })
        );
        dispatch(setShift(null));
        dispatch(setCashes([]));
        return true;
      }
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { start, close, isLoading };
};
